import { render, staticRenderFns } from "./ControlloDDT.vue?vue&type=template&id=41e3c0d4&"
import script from "./ControlloDDT.vue?vue&type=script&lang=js&"
export * from "./ControlloDDT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports